export interface NamedOption {
  id: number;
  key: string;
  name: string;
}

export interface OrgOption {
  id: number;
  name: string;
}

export interface AdminUserPermissions {
  create_individual: boolean;
  create_bulk: boolean;
  edit_individual: boolean;
  edit_bulk: boolean;
  create_client: boolean;
  create_catalyx: boolean;
  edit_client: boolean;
  edit_catalyx: boolean;
  view_all_organizations: boolean;
}

export interface UsersMeta {
  organizations: OrgOption[];
  user_types: NamedOption[];
  catalyx_roles: NamedOption[];
  client_roles: NamedOption[];
  permissions: AdminUserPermissions;
}

export interface AdminUser {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  name: string;
  company: string | null;
  is_active: boolean;
  user_type_id: number | null;
  user_type_key: string | null;
  user_type_name: string | null;
  catalyx_role_id: number | null;
  catalyx_role_key: string | null;
  catalyx_role_name: string | null;
  client_role_id: number | null;
  client_role_key: string | null;
  client_role_name: string | null;
  organization_id: number | null;
  organization_name: string | null;
  org_id: number | null;
  org_name: string | null;
}

export interface UserFormValue {
  email: string;
  first_name: string;
  last_name: string;
  company: string;
  organization_id: number | '';
  user_type_id: number | '';
  catalyx_role_id: number | '';
  client_role_id: number | '';
}

export interface UserListResponse {
  count: number;
  page: number;
  page_size: number;
  results: AdminUser[];
}

export interface BulkRowResult {
  row?: number;
  id?: number;
  email: string;
  status: string;
  message: string;
}

export interface BulkCreateResponse {
  dry_run: boolean;
  created: number;
  errors: number;
  results: BulkRowResult[];
}

export interface BulkActionResponse {
  updated: number;
  errors: number;
  results: BulkRowResult[];
}

export const USERS_SUBTAB_CAPS = {
  createIndividual: 'admin_panel_create_user_individual',
  createBulk: 'admin_panel_create_user_bulk',
  editIndividual: 'admin_panel_edit_user_individual',
  editBulk: 'admin_panel_edit_user_bulk',
} as const;

export const emptyUserForm = (): UserFormValue => ({
  email: '',
  first_name: '',
  last_name: '',
  company: '',
  organization_id: '',
  user_type_id: '',
  catalyx_role_id: '',
  client_role_id: '',
});

export function formFromUser(user: AdminUser): UserFormValue {
  return {
    email: user.email || '',
    first_name: user.first_name || '',
    last_name: user.last_name || '',
    company: user.company || '',
    organization_id: user.organization_id ?? '',
    user_type_id: user.user_type_id ?? '',
    catalyx_role_id: user.catalyx_role_id ?? '',
    client_role_id: user.client_role_id ?? '',
  };
}

export function formToPayload(value: UserFormValue) {
  return {
    email: value.email.trim(),
    first_name: value.first_name,
    last_name: value.last_name,
    company: value.company,
    organization_id: value.organization_id === '' ? null : value.organization_id,
    user_type_id: value.user_type_id === '' ? null : value.user_type_id,
    catalyx_role_id: value.catalyx_role_id === '' ? null : value.catalyx_role_id,
    client_role_id: value.client_role_id === '' ? null : value.client_role_id,
  };
}
